/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { ChildExcelResultDto } from '../models/child-excel-result-dto';
import { excelControllerChildExcelUpload } from '../fn/excel/excel-controller-child-excel-upload';
import { ExcelControllerChildExcelUpload$Params } from '../fn/excel/excel-controller-child-excel-upload';
import { excelControllerCouponExcelUpload } from '../fn/excel/excel-controller-coupon-excel-upload';
import { ExcelControllerCouponExcelUpload$Params } from '../fn/excel/excel-controller-coupon-excel-upload';
import { excelControllerGrowthCenterExcelUpload } from '../fn/excel/excel-controller-growth-center-excel-upload';
import { ExcelControllerGrowthCenterExcelUpload$Params } from '../fn/excel/excel-controller-growth-center-excel-upload';

@Injectable({ providedIn: 'root' })
export class ExcelService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `excelControllerChildExcelUpload()` */
  static readonly ExcelControllerChildExcelUploadPath = '/api/excel/child';

  /**
   * 엑셀로 받은 아동 데이터를 업로드합니다.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `excelControllerChildExcelUpload()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  excelControllerChildExcelUpload$Response(params: ExcelControllerChildExcelUpload$Params, context?: HttpContext): Observable<StrictHttpResponse<ChildExcelResultDto>> {
    return excelControllerChildExcelUpload(this.http, this.rootUrl, params, context);
  }

  /**
   * 엑셀로 받은 아동 데이터를 업로드합니다.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `excelControllerChildExcelUpload$Response()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  excelControllerChildExcelUpload(params: ExcelControllerChildExcelUpload$Params, context?: HttpContext): Observable<ChildExcelResultDto> {
    return this.excelControllerChildExcelUpload$Response(params, context).pipe(
      map((r: StrictHttpResponse<ChildExcelResultDto>): ChildExcelResultDto => r.body)
    );
  }

  /** Path part for operation `excelControllerCouponExcelUpload()` */
  static readonly ExcelControllerCouponExcelUploadPath = '/api/excel/coupon';

  /**
   * 엑셀로 받은 쿠폰 데이터를 업로드합니다.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `excelControllerCouponExcelUpload()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  excelControllerCouponExcelUpload$Response(params: ExcelControllerCouponExcelUpload$Params, context?: HttpContext): Observable<StrictHttpResponse<ChildExcelResultDto>> {
    return excelControllerCouponExcelUpload(this.http, this.rootUrl, params, context);
  }

  /**
   * 엑셀로 받은 쿠폰 데이터를 업로드합니다.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `excelControllerCouponExcelUpload$Response()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  excelControllerCouponExcelUpload(params: ExcelControllerCouponExcelUpload$Params, context?: HttpContext): Observable<ChildExcelResultDto> {
    return this.excelControllerCouponExcelUpload$Response(params, context).pipe(
      map((r: StrictHttpResponse<ChildExcelResultDto>): ChildExcelResultDto => r.body)
    );
  }

  /** Path part for operation `excelControllerGrowthCenterExcelUpload()` */
  static readonly ExcelControllerGrowthCenterExcelUploadPath = '/api/excel/growth-center';

  /**
   * 엑셀로 받은 발달센터 데이터를 업로드합니다.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `excelControllerGrowthCenterExcelUpload()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  excelControllerGrowthCenterExcelUpload$Response(params: ExcelControllerGrowthCenterExcelUpload$Params, context?: HttpContext): Observable<StrictHttpResponse<ChildExcelResultDto>> {
    return excelControllerGrowthCenterExcelUpload(this.http, this.rootUrl, params, context);
  }

  /**
   * 엑셀로 받은 발달센터 데이터를 업로드합니다.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `excelControllerGrowthCenterExcelUpload$Response()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  excelControllerGrowthCenterExcelUpload(params: ExcelControllerGrowthCenterExcelUpload$Params, context?: HttpContext): Observable<ChildExcelResultDto> {
    return this.excelControllerGrowthCenterExcelUpload$Response(params, context).pipe(
      map((r: StrictHttpResponse<ChildExcelResultDto>): ChildExcelResultDto => r.body)
    );
  }

}
